import React, { useContext } from 'react';
import clsx from 'clsx';

import './index.scss';
import LodingImage from 'assets/loading.svg';
import PcSideArea from 'components/organisms/PcSideArea';
import PcTitle from 'components/organisms/PcTitle';
import PcFooter from 'components/organisms/PcFooter';
import PcButtonArea from 'components/molecules/PcButtonArea';

import { PAGE_MAP, THANKS_URL, FATAL_ERROR_MESSAGES } from 'utils/constant';
import {
  getChoiceLabel,
  useAnalytics,
  useWindowDimensions,
} from 'utils';
import AppContext from 'fluxes/context';

// サイドエリアに表示する文字列を作成
const makeSideAreaSelects = ({
  ekiName,
  moveTypeCd,
  moveTime,
  jobType1Cd,
  jobType2Cd,
  excelLv,
  powerPointLv,
  wordLv,
  accessLv,
}) => {
  return [
    [
      ekiName ? `${ekiName}駅` : null,
      moveTypeCd ? `${getChoiceLabel('moveTypeCdList', moveTypeCd)}${moveTime}分` : null,
    ]
  ];
};

// PC用のテンプレート
const PcBasicTemplate = ({ 
  path,
  children,
  onClickMainButton,
  valid,
  isApiError,
  showLoading,
  lpMode,
}) => {
  const { state } = useContext(AppContext);
  const { isModify } = state;
  const { step, subStep, title, subTitle, prevUrl, nextUrl, buttonType } = PAGE_MAP[path];
  const selects = makeSideAreaSelects(state);
  
  useAnalytics(lpMode); // Web計測
  const { height } = useWindowDimensions();
  
  const isOver768 = !lpMode && height > 768;

  const showProgress = path !== THANKS_URL;

  return (
    <div className={clsx('PcBasicTemplate', { isOver768 })}>
      <div className="center">
        <div className="wrapper">
          <div className="side">
            <PcSideArea step={step} selects={selects} isOver768={isOver768} showProgress={showProgress} lpMode={lpMode} />
          </div>
          <div className="main">
            <div className="title">
              <PcTitle
                step={step}
                subStep={subStep}
                title={title}
                subTitle={subTitle}
              />
            </div>
            <div className="children">
              {children}
            </div>
            <div className="button-area">
              <PcButtonArea
                onClickMainButton={onClickMainButton}
                prevUrl={prevUrl}
                nextUrl={nextUrl}
                isModify={isModify}
                buttonType={buttonType}
                valid={valid}
                lpMode={lpMode}
              />
            </div>
          </div>
        </div>
      </div>
      {!lpMode && (
        <div className="footer-wrapper">
          <div className="footer">
            <PcFooter />
          </div>
        </div>
      )}
      {/* ローディング */}
      {showLoading && (
        <div className="loading-modal-wrapper">
          <div className="loading-modal-wrapper-background">
            <img className="loading-image" src={LodingImage} alt="loading" />
          </div>
        </div>
      )}
      {/* APIエラーモーダル */}
      {isApiError && (
        <div className="api-error-modal-wrapper">
          <div className="api-error-modal-wrapper-background">
            <div className="api-error-modal">
              {FATAL_ERROR_MESSAGES.map(message => <div key={message}>{message}</div>)}
              <div className="api-error-top-link"><a href="/jobma/">Jobマ!トップへ戻る</a></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PcBasicTemplate;